import PopoverDisclosure from "../../core-ui/PopoverDisclosure.tsx";
import { useIntl } from "react-intl";
import { clsx } from "clsx";
import BaseLinkOrButton from "../../core-ui/BaseLinkOrButton.tsx";
import MiscellaneousEllipsis from "../../icons/MiscellaneousEllipsis.tsx";
import { ManageAsset } from "../../api/decimal/common-types/manageAssets.ts";

export type LinksType = {
  label: string;
  href?: string;
  onClick?: () => void;
  to?: string;
}[];

export default function AssetPopoverLink({
  asset,
  className,
  links,
}: {
  asset: ManageAsset | VST.Bridge.Asset;
  className?: string;
  links: LinksType;
}) {
  const intl = useIntl();

  if (links.length === 0) {
    return null;
  }

  return (
    <PopoverDisclosure
      placement="bottom-end"
      xOffset={-4}
      renderTrigger={(props) => (
        <button
          {...props}
          aria-label={intl.formatMessage(
            {
              defaultMessage: "More Options for {title}",
            },
            { title: asset.title }
          )}
          data-tooltip-content={intl.formatMessage({
            defaultMessage: "More Options",
          })}
          className={clsx(
            "vst-icon-button-circle",
            "vst-icon-button-size-small",
            "vst-icon-button-variant-black",
            "vst-icon-button-option-compact",
            "vst-icon-button-option-negative-margin",
            className
          )}
        >
          <MiscellaneousEllipsis />
        </button>
      )}
    >
      <div className="vst-popover">
        <ul className="vst-popover-section vst-popover-link-list">
          {links.map(({ label, href, onClick, to }) => (
            <li key={label}>
              <BaseLinkOrButton href={href} onClick={onClick} to={to}>
                {label}
              </BaseLinkOrButton>
            </li>
          ))}
        </ul>
      </div>
    </PopoverDisclosure>
  );
}
